<script setup lang="ts">
  import { Text, IconChevronRight } from "@ui-kit";

  const { count, total } = defineProps<{
    count: number;
    total: number;
  }>();
</script>

<template>
  <div class="items-in-zone" data-testid="check-binding-items-in-zone">
    <div class="items-in-zone__content">
      <Text>{{ $t("Цветомодели в зоне") }}</Text>
      <div class="items-in-zone__count">
        <Text data-testid="items-in-zone-count">{{ count }}</Text>
        <Text font="body-regular-18" data-testid="items-in-zone-total">/ {{ total }}</Text>
      </div>
    </div>
    <IconChevronRight :style="{ width: '32px', height: '32px' }" />
  </div>
</template>

<style scoped>
  .items-in-zone {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    background-color: var(--sf-base-background-secondary);
    padding: 16px;
    border-radius: 16px;
  }

  .items-in-zone__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
  }

  .items-in-zone__count {
    display: flex;
    gap: 6px;
    align-items: flex-end;

    & :deep(.text) {
      &:first-of-type {
        font-weight: 580;
        font-size: 40px;
        line-height: 52px;
        letter-spacing: 0;
      }

      &:last-of-type {
        margin-bottom: 8px;
      }
    }
  }
</style>
